import React, { useCallback, useMemo } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import PropTypes from 'prop-types'

import FormDrawerWrapper from '../../../../../features/components/FormDrawerWrapper'
import SkeletonSingleSectionForm from '../../../../../features/components/FormDrawerWrapper/Skeletons/SkeletonSingleSectionForm'
import SroiReportPayloadEditForm from './SroiReportPayloadEditForm'

import useManageEditFormData from '../../../../../hooks/formHooks/useManageEditFormData'
import useManageDrawer from '../../../../../hooks/formHooks/useManageDrawer'

import {
  getSroiReportPayloadIsLoadingSelector,
  sroiReportPayloadSelector
} from '../../../../../modules/selectors/socialReturnOnInvestment'
import {
  clearGetSroiReportPayload,
  getSroiReportPayload
} from '../../../../../modules/actions/socialReturnOnInvestment'

import { SROI_REPORT_PAYLOAD_EDIT } from '../../../../../constants/forms'

const SroiReportPayloadEdit = ({ fetchSroiReportHandler }) => {
  const dispatch = useDispatch()

  const sroiReportPayload = useSelector(sroiReportPayloadSelector)
  const getSroiReportPayloadIsLoading = useSelector(getSroiReportPayloadIsLoadingSelector)

  const isFormLoading = useMemo(() => {
    return getSroiReportPayloadIsLoading || !sroiReportPayload
  }, [getSroiReportPayloadIsLoading, sroiReportPayload])

  const { selectedEditItemId } = useManageDrawer({
    formName: SROI_REPORT_PAYLOAD_EDIT
  })

  const getSroiReportPayloadHandler = useCallback(() => {
    dispatch(getSroiReportPayload({ id: selectedEditItemId }))
  }, [dispatch, selectedEditItemId])

  const clearSroiReportPayloadHandler = useCallback(() => {
    dispatch(clearGetSroiReportPayload())
  }, [dispatch])

  useManageEditFormData({
    formName: SROI_REPORT_PAYLOAD_EDIT,
    loadedDataId: sroiReportPayload.id,
    getDataHandler: getSroiReportPayloadHandler,
    clearDataHandler: clearSroiReportPayloadHandler
  })

  return (
    <FormDrawerWrapper
      formName={SROI_REPORT_PAYLOAD_EDIT}
      SkeletonFormComponent={SkeletonSingleSectionForm}
      title="SROI Input Values"
      isFormLoading={isFormLoading}
      showOpenButton={false}
    >
      <SroiReportPayloadEditForm fetchSroiReportHandler={fetchSroiReportHandler} />
    </FormDrawerWrapper>
  )
}

SroiReportPayloadEdit.propTypes = {
  fetchSroiReportHandler: PropTypes.func.isRequired
}

export default SroiReportPayloadEdit
